module.exports = require("./fr-MG");